module.exports = __webpack_public_path__ + "sunsemweb/img/c1.8b84aea4.png";